import { Tag } from "antd";
import moment from "moment";
import AntDropdown from "../../../../components/CustomDropdown/AntDropdown";

export const AdminColumns = (handleDropDown) => [
  {
    title: "Full Name",
    dataIndex: "fullName",
    ellipsis: true,
  },
  {
    title: "Email",
    dataIndex: "email",
    ellipsis: true,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (status) => {
      return status.toLowerCase() !== "closed" ? (
        <Tag
          style={{
            backgroundColor: "#d1fae5",
            color: "#065f46",
            border: "none",
          }}
        >
          {status}
        </Tag>
      ) : (
        <Tag
          style={{
            backgroundColor: "#fee2e2",
            color: "#991b1b",
            border: "none",
          }}
        >
          {status}
        </Tag>
      );
    },
    ellipsis: true,
  },

  {
    title: "Roles",
    dataIndex: "roles",
    render: (roles) => {
      if (!roles || !Array.isArray(roles) || roles.length === 0) {
        return <Tag style={{ border: "none", backgroundColor: "rgba(0,0,0,0.04)" }}>N/A</Tag>;
      }

      const getRoleStyle = (role) => {
        const r = role.toLowerCase();
        if (r === "super_admin") return { bgColor: "#e0f2fe", color: "#0369a1", label: "Super Admin" };
        if (r === "owner") return { bgColor: "#fef3c7", color: "#b45309", label: "Owner" };
        if (r === "marketer") return { bgColor: "#f3e8ff", color: "#6b21a8", label: "Marketer" };
        if (r === "finance") return { bgColor: "#dcfce7", color: "#166534", label: "Finance" };
        if (r === "operations") return { bgColor: "#ffedd5", color: "#9a3412", label: "Operations" };
        if (r === "disbursement_officer") return { bgColor: "#fce7f3", color: "#9d174d", label: "Disbursement" };
        
        return { 
          bgColor: "rgba(0,0,0,0.04)", 
          color: "inherit", 
          label: role.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) 
        };
      };

      return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
          {roles.map((role, index) => {
            const style = getRoleStyle(role);
            return (
              <Tag
                key={index}
                style={{
                  padding: "2px 8px",
                  borderRadius: "6px",
                  fontSize: "11px",
                  backgroundColor: style.bgColor,
                  color: style.color,
                  border: "none",
                  fontWeight: 500
                }}
              >
                {style.label}
              </Tag>
            );
          })}
        </div>
      );
    },
  },

  {
    title: "Flow",
    dataIndex: "permissions",
    render: (permissions) => {
      const flows = new Set();
      if (Array.isArray(permissions)) {
        permissions.forEach((p) => {
          const name = (p?.name || "").toUpperCase();
          if (name.includes("INITIATOR")) flows.add("INITIATOR");
          if (name.includes("APPROVER")) flows.add("APPROVER");
        });
      }

      if (flows.size === 0) {
        return (
          <Tag style={{ border: "none", backgroundColor: "rgba(0,0,0,0.04)" }}>
            N/A
          </Tag>
        );
      }

      const styleFor = (flow) =>
        flow === "APPROVER"
          ? { bgColor: "#dcfce7", color: "#166534", label: "Approver" }
          : { bgColor: "#dbeafe", color: "#1e40af", label: "Initiator" };

      return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
          {Array.from(flows).map((flow) => {
            const style = styleFor(flow);
            return (
              <Tag
                key={flow}
                style={{
                  padding: "2px 8px",
                  borderRadius: "6px",
                  fontSize: "11px",
                  backgroundColor: style.bgColor,
                  color: style.color,
                  border: "none",
                  fontWeight: 500,
                }}
              >
                {style.label}
              </Tag>
            );
          })}
        </div>
      );
    },
  },

  {
    title: "Access Type",
    dataIndex: "userType",
    render: (userType) => {
      return (
        <Tag
          style={{
            padding: "2px 8px",
            borderRadius: "6px",
            fontSize: "12px",
            backgroundColor: "#e0f7fa",
            color: "#006064",
            fontWeight: 500,
            border: "none",
            textTransform: "capitalize",
          }}
        >
          {userType?.toLowerCase()}
        </Tag>
      );
    },
  },
  {
    title: "Date Created",
    dataIndex: "createdAt",
    render: (createdAt) => moment(createdAt).format("YYYY-MM-DD HH:mm"),
    ellipsis: true,
  },
  {
    title: "Action",
    render: (record) => {
      const id = record.userId;
      const options = ["View Details", "Change Role", "Activity Log", "Delete"];
      if (record.isActive) {
        options.push("Deactivate");
      } else {
        options.push("Activate");
      }
      return (
        <AntDropdown
          dropDownOptions={options}
          handleDropdownAction={(item) => handleDropDown(item, record)}
          userId={id}
          isArrow
        />
      );
    },
    ellipsis: true,
  },
];
